import React from 'react';
import './CommunityTopBar.css';

interface CommunityTopBarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onNotificationsClick?: () => void;
  onBackToMain?: () => void;
  userDisplayName?: string;
  avatarUrl?: string | null;
}

const CommunityTopBar: React.FC<CommunityTopBarProps> = ({
  searchValue,
  onSearchChange,
  onNotificationsClick,
  onBackToMain,
  userDisplayName,
  avatarUrl,
}) => {
  return (
    <header className="community-shell__topbar">
      <button type="button" className="community-shell__topbar-logo" onClick={onBackToMain}>
        <div className="community-shell__topbar-logo-mark" aria-hidden />
        <div className="community-shell__topbar-logo-text">
          <strong>Herbal Circle</strong>
          <span>AI 医疗助手社区</span>
        </div>
      </button>
      <div className="community-shell__topbar-search">
        <input
          type="search"
          placeholder="搜索用户、话题或帖子"
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>
      <div className="community-shell__topbar-actions">
        <button type="button" onClick={onNotificationsClick} aria-label="查看通知">
          <span className="community-shell__topbar-notice-dot" />
          <span className="community-shell__topbar-icon" aria-hidden />
        </button>
        <div className="community-shell__topbar-avatar" title={userDisplayName ?? '社区用户'}>
          {avatarUrl ? <img src={avatarUrl} alt={userDisplayName ?? '社区用户'} /> : <span>{userDisplayName?.slice(0, 1) ?? '我'}</span>}
        </div>
      </div>
    </header>
  );
};

export default CommunityTopBar;
